module.exports = __webpack_public_path__ + "img/pdf-icon-inactive.4e81ff87.svg";